import React from 'react'
import PicCont from './PicCont';
import LinkWrap from './LinkWrap';
import lineToBr from './lineToBr';
import { helper } from '../utilities/helper';
import catPictures from '../utilities/catPictures'
import AudioAction from './design-system/audio/AudioAction';
import RelatedServices from './design-system/marketing/RelatedServices';
import MarketingIsland from './design-system/marketing/MarketingIsland';
const SimilarCats = ({priority, subCate, cat, children, className, newStyle, noTitle, ui, eyebrow, heading, description, additionalServices }) => {

  let getSrc = (subCat) => catPictures[helper.makeUrl(['Mixers', 'Bundle'].includes(helper.makeUrl(subCat)) ? cat + ' ' + helper.tagLower(subCat) : helper.tagLower(subCat))]

  if (ui === 'v2') return <MarketingIsland>
    <RelatedServices
      subCategory={subCate}
      eyebrow={eyebrow}
      heading={heading}
      description={description}
      additionalServices={additionalServices}
    />
  </MarketingIsland>

  if (newStyle) return <section className={`newSim ${className}`}>
    {children || (!noTitle && <div className="upperBold">Frequently Rented Together</div>)}
    <div className="row">
      {subCate.similar_categories?.filter(sc => sc.h1).map((sc, i) => ui === 'v2' ? <AudioAction mode='card' key={i} href={sc.url} className='similarCat' wrapContent={false}>
        {getSrc(sc.name) && <PicCont priority alt={sc.name} src={getSrc(sc.name)} height={300} width={300} />}
        <div className='col'>
          <strong className='upperBold'>{sc.h1 || sc.name}</strong>
          <p>{lineToBr(sc.miniText)}</p>
        </div>
      </AudioAction> : <LinkWrap key={i} href={sc.url} className='similarCat'>
        {getSrc(sc.name) && <PicCont priority alt={sc.name} src={getSrc(sc.name)} height={300} width={300} />}
        <div className='col'>
          <strong className='upperBold'>{sc.h1 || sc.name}</strong>
          <p>{lineToBr(sc.miniText)}</p>
        </div>
      </LinkWrap>)}
    </div>
  </section>


  return <section className={`similarCats ${className} ${newStyle ? 'newSim' : ''}`}>
    {children || <div className="upperBold">Frequently Rented Together</div>}

    <div className="row">
      {subCate.similar_categories?.filter(sc => sc.h1).map((sc, i) => ui === 'v2' ? <AudioAction mode='card' key={i} href={sc.url} className='similarCat' wrapContent={false}>
        <PicCont background picture={sc.mini_pic || 'stage-rental-og.jpg'} />
        <div className="back"></div>
        <div className="col">

          <div className='row'>
            {getSrc(sc.name) && <PicCont priority={priority} alt={sc.name} src={getSrc(sc.name)} height={100} width={100} />}
            <div className='shape'></div>
            <strong className='upper'>{sc.h1 || sc.name}</strong>

          </div>
          {newStyle && <p>{lineToBr(sc.miniText)}</p>}

        </div>
      </AudioAction> : <LinkWrap key={i} href={sc.url} className='similarCat'>
        <PicCont background picture={sc.mini_pic || 'stage-rental-og.jpg'} />
        <div className="back"></div>
        <div className="col">

          <div className='row'>
            {getSrc(sc.name) && <PicCont priority={priority} alt={sc.name} src={getSrc(sc.name)} height={100} width={100} />}
            <div className='shape'></div>
            <strong className='upper'>{sc.h1 || sc.name}</strong>

          </div>
          {newStyle && <p>{lineToBr(sc.miniText)}</p>}

        </div>
      </LinkWrap>)}
    </div>
  </section>
}

export default SimilarCats
